import React, { FC, useCallback, useState } from "react";
import { AppInfo } from "../types";
import styles from "./styles.module.less";
import Avatar from "antd/lib/avatar/avatar";
import { useTranslation } from "react-i18next";
import { Button, ConfigProvider } from "antd";
import classNames from "classnames";

export interface MobileAddAppProps {
  allApps: AppInfo[];
  orderedApps: AppInfo[];
  removeAppRequest: (id: string) => Promise<void>;
  installAppRequest: (id: string) => Promise<void>;
}

const AppItem: FC<{
  removeAppRequest: (id: string) => Promise<void>;
  installAppRequest: (id: string) => Promise<void>;
  appInfo: AppInfo;
  orderedApps: AppInfo[];
}> = ({ removeAppRequest, orderedApps, appInfo, installAppRequest }) => {
  const { t } = useTranslation();
  const [removing, setRemoving] = useState(false);
  const [installing, setInstalling] = useState(false);

  const isInstalled = useCallback(
    (id) => {
      return orderedApps.some((item) => item.id.split("/")[0] === id);
    },
    [orderedApps]
  );

  return (
    <div key={appInfo.id} className={styles.mobileAddAppItem}>
      <Avatar
        size={48}
        shape="square"
        style={{
          borderRadius: 8,
          flexShrink: 0,
        }}
        src={appInfo.logo}
      ></Avatar>

      <div className={styles.mobileAddAppNameAndDesc}>
        <h5 className={styles.mobileAppName}>{appInfo.name}</h5>
        <p className={styles.mobileAppDesc}>
          {appInfo.description || t("common.noDescNow")}
        </p>
      </div>

      <ConfigProvider autoInsertSpaceInButton={false}>
        {isInstalled(appInfo.id) ? (
          <Button
            loading={removing}
            className={classNames(
              styles.mobileToggleAppBtn,
              styles.mobileRemoveAppBtn
            )}
            onClick={async () => {
              setRemoving(true);
              try {
                await removeAppRequest(appInfo.id);
              } catch (e) {
                console.error(e);
              } finally {
                setRemoving(false);
              }
            }}
          >
            {t("common.uninstall")}
          </Button>
        ) : (
          <Button
            loading={installing}
            className={styles.mobileToggleAppBtn}
            type="primary"
            onClick={async () => {
              setInstalling(true);
              try {
                await installAppRequest(appInfo.id);
              } catch (e) {
                console.error(e);
              } finally {
                setInstalling(false);
              }
            }}
          >
            {t("common.install")}
          </Button>
        )}
      </ConfigProvider>
    </div>
  );
};

export const MobileAddApp: FC<MobileAddAppProps> = ({
  allApps,
  orderedApps,
  removeAppRequest,
  installAppRequest,
}) => {
  return (
    <div className={styles.mobileAddApp}>
      {allApps.map((item) => {
        return (
          <AppItem
            installAppRequest={installAppRequest}
            key={item.id}
            orderedApps={orderedApps}
            removeAppRequest={removeAppRequest}
            appInfo={item}
          />
        );
      })}
    </div>
  );
};
